import { useTranslate } from 'ra-core';
import { Button } from '../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';

type ConfirmDiscardChannelModalProps = {
  open: boolean;
  onClose: () => void;
  onDiscard: () => void;
};

/**
 * Used to confirm discarding a channel when there are no messages in it. It's shown in two cases:
 *  - when the user tries to navigate away from the channel using app's router (different route than chat)
 *  - when the user tries to select different channel from the list of channels without changing the actual route
 */
export const ConfirmDiscardChannelModal = ({
  open,
  onClose,
  onDiscard,
}: ConfirmDiscardChannelModalProps) => {
  const translate = useTranslate();

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onClose();
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {translate('chat.discardChannelModalTitle')}
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          {translate('chat.discaradChannelModalContent')}
        </DialogDescription>
        <DialogFooter>
          <Button type="button" variant="ghost" onClick={onDiscard}>
            {translate('chat.discard')}
          </Button>
          <Button type="button" onClick={onClose}>
            {translate('chat.stay')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
